module.exports = __webpack_public_path__ + "img/gkrymnst.06d787e0.png";